import React from 'react';
import CurrencySelect from './CurrencySelect';
import { useLocale } from '../../../contexts/LocaleContext';

export default function BankFieldsForm({ form, setForm, showDefault = false }) {
  const { t } = useLocale();

  return (
    <>
      <div className="grid grid-cols-2 gap-2">
        <input
          placeholder={t('plugins.bankFieldAccountHolder')}
          value={form.accountHolder}
          onChange={(e) => setForm({ ...form, accountHolder: e.target.value })}
          className="px-4 py-2 bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-lg text-xs focus:border-[var(--accent-primary)] focus:outline-none text-[var(--text-primary)] placeholder-[var(--text-tertiary)]"
        />
        <input
          placeholder={t('plugins.bankFieldBankName')}
          value={form.bankName}
          onChange={(e) => setForm({ ...form, bankName: e.target.value })}
          className="px-4 py-2 bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-lg text-xs focus:border-[var(--accent-primary)] focus:outline-none text-[var(--text-primary)] placeholder-[var(--text-tertiary)]"
        />
        <input
          placeholder={t('plugins.bankFieldAccountNumber')}
          value={form.accountNumber}
          onChange={(e) => setForm({ ...form, accountNumber: e.target.value })}
          className="px-4 py-2 bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-lg text-xs focus:border-[var(--accent-primary)] focus:outline-none text-[var(--text-primary)] placeholder-[var(--text-tertiary)]"
        />
        <input
          placeholder={t('plugins.bankFieldRoutingNumber')}
          value={form.routingNumber}
          onChange={(e) => setForm({ ...form, routingNumber: e.target.value })}
          className="px-4 py-2 bg-[var(--bg-tertiary)] border border-[var(--border-color)] rounded-lg text-xs focus:border-[var(--accent-primary)] focus:outline-none text-[var(--text-primary)] placeholder-[var(--text-tertiary)]"
        />
        <CurrencySelect
          value={form.currency}
          onChange={(code) => setForm({ ...form, currency: code })}
        />
      </div>
      {showDefault && (
        <label className="flex items-center gap-2 text-xs text-[var(--text-secondary)] cursor-pointer mt-1">
          <input
            type="checkbox"
            checked={form.isDefault}
            onChange={(e) => setForm({ ...form, isDefault: e.target.checked })}
            className="rounded border-[var(--border-color)]"
          />
          {t('plugins.bankFieldSetAsDefault')}
        </label>
      )}
    </>
  );
}

export const EMPTY_BANK_FORM = {
  accountHolder: '',
  bankName: '',
  accountNumber: '',
  routingNumber: '',
  currency: 'USD',
  isDefault: false,
};